import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  consulta: {
    loading: false,
    error: false,
    message: "",
  },
};

const ConsultaMassivaSlice = createSlice({
  name: 'consultaMassiva',
  initialState,
  reducers: {
    consultaMassivaRequest: (state) => {
      state.consulta.loading = true;
      state.consulta.error = null;
    },
    consultaMassivaSuccess: (state, action) => {
      state.consulta.loading = false;
      state.consulta.error = false;
      state.message = action.payload.response.data.message;

    },
    consultaMassivaFailure: (state, action) => {
      state.consulta.loading = false;
      state.consulta.error = action.payload;
    },
    consultaMassivaItauRequest: (state) => {
      state.consulta.loading = true;
      state.consulta.error = null;
    },
    consultaMassivaItauSuccess: (state, action) => {
      state.consulta.loading = false;
      state.consulta.error = false;
      state.message = action.payload.response.data.message;

    },
    consultaMassivaItauFailure: (state, action) => {
      state.consulta.loading = false;
      state.consulta.error = action.payload;
    },
    clear: (state) => {
      state.consulta.loading = false;
      state.consulta.error = false;
      state.message = "";
    }
  }
});

export const {
  consultaMassivaSuccess,
  consultaMassivaFailure,
  consultaMassivaRequest,
  consultaMassivaItauRequest,
  consultaMassivaItauSuccess,
  consultaMassivaItauFailure,
  clear
} = ConsultaMassivaSlice.actions;

export default ConsultaMassivaSlice.reducer;
